var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[_c('b-alert',{attrs:{"show":!!_vm.errorHandlingMessage,"variant":"danger","dismissible":""}},[_vm._v(_vm._s(_vm.errorHandlingMessage))]),(_vm.imageUrl)?_c('b-img-lazy',{attrs:{"src":_vm.imageUrl,"alt":_vm.imageTitle,"center":"","fluid":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }